import React, { useEffect, useState } from 'react'
import IconsTextNavigation from 'components/global/IconsTextNavigation'
import { classesEventStore } from 'state/classes/classesStore'
import ItemsToBringModal from 'pages/Events/Views/Common/Modals/ItemsToBring'

const ItemstoBring: React.FC = () => {
  const { classesData, itemsToBring, setItemsToBring } = classesEventStore(
    store => ({
      classesData: store.classesData,
      itemsToBring: store.itemsToBring,
      setItemsToBring: store.setItemsToBring,
    }),
  )
  const [openItemsModal, setOpenItemsModal] = useState<boolean>(false)

  return (
    <>
      <div onClick={() => setOpenItemsModal(true)}>
        <IconsTextNavigation
          iconName="ShoppingBagOpen"
          heading="Items to bring"
          isCompleted={itemsToBring.length > 0 ? true : false}
        />
      </div>
      {openItemsModal && (
        <ItemsToBringModal
          openModal={openItemsModal}
          closeModal={setOpenItemsModal}
          prevItems={itemsToBring}
          setPrevItems={setItemsToBring}
          organizationId={classesData.organizationId}
        />
      )}
    </>
  )
}

export default ItemstoBring
